import React, { createRef } from 'react';
import { IonLoading, IonButton, IonChip, IonCard, IonCardHeader, IonCardTitle, IonCardContent, IonActionSheet, IonInput, IonButtons, IonBackButton, IonFab, IonFabButton, IonIcon, IonContent, IonHeader, IonItem, IonLabel, IonList, IonPage, IonTitle, IonToolbar, withIonLifeCycle } from '@ionic/react';
import '../styles/Studyset.scss';
import Storage from '../Storage';
import Utilities from '../Utilities';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import { checkbox, checkmarkDone, close, closeCircle, copy, fileTrayFull, language, newspaper, square, squareOutline } from 'ionicons/icons'
import '../styles/TagEditorModal.scss';
import '../styles/AggregatorModal.scss';
import Drawer from '@material-ui/core/Drawer';
import { isPlatform } from '@ionic/react';
import Server from '../Server';

class AggregatorModal extends React.Component {

    constructor(props) {

        super(props);
        this.modalRef = createRef();
        this.state = {
            view: "options",
            resultType: null,
            results: []
        }

    }

    componentWillReceiveProps() {
        if (this.props.open === null) {
            this.setState({
                results: [],
                view: "options"
            })
            Utilities.onDrawerShow();
        }
    }

    async contextSearch(actuallyTranslateSearch) {
        this.setState({ view: "loading" })
        let searchCount = parseInt(localStorage.getItem(actuallyTranslateSearch ? "translateSearchCount" : "contextSearchCount")) || 0;

        if (!window.activated && searchCount > 4) {
            window.showSubscriptionModal(actuallyTranslateSearch ? "translation" : "context");
            return;
        }

        Utilities.trackEvent("Aggregator", actuallyTranslateSearch ? "Translate" : "Context", this.props.open === "term" ?  this.props.term : this.props.definition)
        
        let results = await Server.getContext(
            this.props.open === "term" ? this.props.termLang : this.props.definitionLang,
            this.props.open === "term" ? this.props.definitionLang : this.props.termLang,
            this.props.open === "term" ?  this.props.term : this.props.definition
        );

        if (results) {
            if (!actuallyTranslateSearch && results.examples && results.examples.length !== 0) {
                this.setState({ 
                    view: "results", 
                    resultType: "context",
                    results: results.examples
                })
            } else if (actuallyTranslateSearch && results.translations && results.translations.length !== 0) {
                this.setState({ 
                    view: "results", 
                    resultType: "translation",
                    results: results.translations.map(item => { return { from: item } })
                })
            } else {
                this.setState({ view: "options" })
                window.toast(window.ln.noMatch);
                return;
            }
        } else {
            this.setState({ view: "options" })
            window.toast(window.ln.noMatch);
            return;
        }
        
        localStorage.setItem(actuallyTranslateSearch ? "translateSearchCount" : "contextSearchCount", searchCount + 1)
    }

    async synonymSearch() {
        this.setState({ view: "loading" })
        let searchCount = parseInt(localStorage.getItem("synonymSearchCount")) || 0;

        if (!window.activated && searchCount > 4) {
            window.showSubscriptionModal("synonym");
            return;
        }
        
        let results = await Server.getSynonym(
            this.props.open === "term" ? this.props.termLang : this.props.definitionLang,
            this.props.open === "term" ?  this.props.term : this.props.definition
        );

        Utilities.trackEvent("Aggregator", "Synonym", this.props.open === "term" ?  this.props.term : this.props.definition)

        if (results && results.results && results.results.length !== 0) {
            this.setState({ 
                view: "results", 
                resultType: "synonym",
                results: results.results.map(item => { return { from: item } })
            })
        } else {
            this.setState({ view: "options" })
            window.toast(window.ln.noMatch);
            return;
        }
        
        localStorage.setItem("synonymSearchCount", searchCount + 1)
    }

    render() {
        if (this.state.view === "loading") {
            return <IonLoading
                isOpen={this.state.view === "loading"}
                message={window.ln.loading}
                duration={10000}
            />
        }

        return (
            <SwipeableDrawer
                anchor="bottom"
                open={this.props.open !== null}
                key="flashcard-editor"
                onClose={ () => {
                    Utilities.onDrawerHide();
                    this.props.onClose(true);
                } }
                onOpen={ () => {

                } }
            >
                <div 
                    className="tag-editor-modal aggregator-modal"
                    data-keyboard-showing={this.state.keyboardShowing} 
                    ref={this.modalRef} 
                >
                    <div className="drag-indicator"></div>
                    <div className="drag-close-indicator" onClick={() => {
                        Utilities.onDrawerHide();
                        this.props.onClose(true);
                    }}>
                        <IonIcon icon={closeCircle} />
                    </div>
                    <section className="edit">
                        { (this.state.view === "options") &&
                            <div className='options'>
                                <div onClick={() => {
                                    this.contextSearch();
                                }}>
                                    <IonIcon icon={newspaper}></IonIcon>
                                    <div className='side'>
                                        <h3>{window.ln.contextSearch}</h3>
                                        <p>{(window.ln.contextSearchText).replace("__", this.props.open === "term" ? this.props.term : this.props.definition) }</p>
                                    </div>
                                </div>
                                <div onClick={() => {
                                    this.contextSearch(true);
                                }}>
                                    <IonIcon icon={language}></IonIcon>
                                    <div className='side'>
                                        <h3>{window.ln.transalteSearch}</h3>
                                        <p>{(window.ln.translateSearchText).replace("__", this.props.open === "term" ? this.props.term : this.props.definition).replace("___", this.props.open === "term" ? this.props.definitionLang : this.props.termLang) }</p>
                                    </div>
                                </div>
                                <div onClick={() => {
                                    this.synonymSearch();
                                }}>
                                    <IonIcon icon={fileTrayFull}></IonIcon>
                                    <div className='side'>
                                        <h3>{window.ln.synonymSearch}</h3>
                                        <p>{(window.ln.synonymSearchText).replace("__", this.props.open === "term" ? this.props.term : this.props.definition) }</p>
                                    </div>
                                </div>
                            </div>
                        }
                        { (this.state.view === "results") &&
                            <div className='results'>
                                <h2>{window.ln.selectToAdd}</h2>
                                <div className='list'>
                                    { this.state.results.map((result, i) => {
                                        return (
                                            <div
                                                onClick={() => {
                                                    let results = this.state.results;
                                                    results[i].selected = !results[i].selected;
                                                    this.setState({ results: results })
                                                }}
                                                data-type={this.state.resultType}
                                            >
                                                <IonIcon icon={result.selected === true ? checkbox : squareOutline} />
                                                <div className='side'>
                                                    { result.from && <span>{result.from}</span> }
                                                    { result.to && <span>{result.to}</span> }
                                                </div>
                                            </div>
                                        )
                                    }) }
                                </div>
                            </div>
                        }
                        <div className="opts">
                            <div className="right">
                                <button onClick={() => {
                                    Utilities.trackEvent("Aggregator", "Aggregator Result Save to Card", null, this.state.results.filter(res => res.selected).length)
                                    this.props.onClose(this.state.resultType, this.state.results.filter(res => res.selected));
                                }}>{this.state.view === "results" && this.state.results.find(res => res.selected) ? window.ln.addToCard : window.ln.close }</button>
                            </div>
                        </div>
                    </section>
               </div>
           </SwipeableDrawer>
        );
    }

};


export default withIonLifeCycle(AggregatorModal);
